module.exports = "/_next/static/images/e36fc807e0d7f8cc915f7597554bf552-calendar-icon.svg.webp";